
import SVGComponent from "./Logo.tsx";
import './App.css';
import {Link} from "react-router-dom";

export function ThankYou() {
  return (
    <div className="teaser-container thank-you">
      <div className="main-content" style={{alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}>
        <div className="header" style={{cursor: 'pointer'}}>
          <Link to="/">
            <SVGComponent height={50} />
          </Link>
        </div>

        <div className="hero">
          <h1 className="hero-title">
            Booking Confirmed!
          </h1>

          <p className="hero-subtitle">
            Thanks so much for booking time with us ,we really appreciate your interest (and/or your willingness to share your insight).
          </p>
        </div>
      </div>
    </div>
  );
}
